import ky from "ky";
import qs from "query-string";
import snakecaseKeys from "snakecase-keys";

import { apiUrls } from "../../urls";
import { getCsrfToken } from "../../utils/getcsrftoken";
import { assertApiResponse } from "../utils/assertapiresponse";

import type { Epicenter } from "./structs";
import { parseEpicenter, parseEpicenters } from "./structs";

export type SearchEpicentersParams = {
    jemOriginTimeFrom: string;
    jemOriginTimeTo: string;
    jemLatFrom: number;
    jemLatTo: number;
    jemLonFrom: number;
    jemLonTo: number;
    jemDepthFrom: number;
    jemDepthTo: number;
    mjmaFrom: number;
    mjmaTo: number;
    eqLocationTypeId: number[];
    mwFrom: number;
    mwTo: number;
    eqMechanismTypeId: number[];
    cmtDepthFrom: number;
    cmtDepthTo: number;
    eqLocationTypeIdSource: number[];
};

/**
 * 震源を検索する。
 *
 * @param params 検索条件
 * @returns 検索条件に該当する震源情報
 */
export const searchEpicenters = async (params?: Partial<SearchEpicentersParams>) => {
    const body = (params) ?
        new URLSearchParams(qs.stringify(snakecaseKeys(params), { arrayFormat: "comma" })) :
        undefined;

    const json = await ky
        .post(
            apiUrls["/sources/search"].post(),
            {
                body,
                headers: { "x-csrftoken": getCsrfToken() },
                credentials: "same-origin",
                mode: "same-origin",
                timeout: 30 * 1000,
                throwHttpErrors: false,
            })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseEpicenters(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};

/**
 * 指定されたIDに対応する震源情報を返す。
 *
 * @param eqSourceId 震源ID
 * @returns 震源情報
 */
export const getEpicenter = async (eqSourceId: Epicenter["eqSourceId"]) => {
    const json = await ky
        .get(
            apiUrls["/sources/[eqSourceId]"].get({ params: { eqSourceId } }),
            { credentials: "same-origin", mode: "same-origin" })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseEpicenter(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};
